import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import * as Sentry from '@sentry/browser';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import StepLesson from './components/StepLesson';
import SetupESP32FlashMicroPython from './components/SetupESP32FlashMicroPython';
import SetupESP32UploadFileBundle from './components/SetupESP32UploadFileBundle';
import * as serviceWorker from './serviceWorker';
import AddToCartButton from './components/AddToCartButton';
import { MathComponent } from 'mathjax-react';
import MathJax from 'react-mathjax-preview';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
});

const cartElem = document.getElementById('cart_component');
const checkoutElem = document.getElementById('checkout_component');

if (cartElem !== null) {
  // Need to also use React.Suspense and wrap around Cart
  //const Cart = React.lazy(() => import('./components/Cart.jsx'));
  ReactDOM.render(
    <React.StrictMode>
      <Cart />
    </React.StrictMode>,
    cartElem
  );
}

if (checkoutElem !== null) {
  ReactDOM.render(
    <React.StrictMode>
      <Checkout />
    </React.StrictMode>,
    checkoutElem
  );
}

const addToCarts = [
  {
    id: 'add_to_cart_hadabot_base_kit_component',
    itemSlug: 'hadabot-base-kit',
  },
  {
    id: 'add_to_cart_hadabot_add_on_speed_sensor',
    itemSlug: 'hadabot-add-on-speed-sensor',
  },
  {
    id: 'add_to_cart_hadabot_add_on_range_sensors',
    itemSlug: 'hadabot-add-on-range-sensors',
  },
];
addToCarts.forEach((addItem) => {
  const addItemElem = document.getElementById(addItem.id);
  if (addItemElem !== null) {
    let promoCode = addItemElem.getAttribute('promo-code');
    promoCode = promoCode === null ? '' : `-${promoCode}`;

    // The promo-code HTML attribute (aka article.promo_code)
    const itemSlug = `${addItem.itemSlug}${promoCode}`;
    ReactDOM.render(
      <React.StrictMode>
        <AddToCartButton itemSlug={itemSlug} />
      </React.StrictMode>,
      addItemElem
    );
  }
});

const stepLessonElem = document.getElementById('step-lesson');
if (stepLessonElem !== null) {
  const lessonSlug = stepLessonElem.getAttribute('lesson-slug');
  const lessonJsonFile = `${stepLessonElem.getAttribute('lesson-js')}.json`;
  ReactDOM.render(
    <div>
      {/* <React.StrictMode> */}
      <StepLesson lessonSlug={lessonSlug} lessonJsonFile={lessonJsonFile} />
      {/* </React.StrictMode> */}
    </div>,
    stepLessonElem
  );
}

const setupESP32FlashMicroPythonElem = document.getElementById(
  'setup-esp32-flash-micropython'
);
if (setupESP32FlashMicroPythonElem !== null) {
  ReactDOM.render(
    <React.StrictMode>
      <SetupESP32FlashMicroPython></SetupESP32FlashMicroPython>
    </React.StrictMode>,
    setupESP32FlashMicroPythonElem
  );
}

const setupESP32UploadFileBundleElem = document.getElementById(
  'setup-esp32-upload-file-bundle'
);
if (setupESP32UploadFileBundleElem !== null) {
  ReactDOM.render(
    <React.StrictMode>
      <SetupESP32UploadFileBundle></SetupESP32UploadFileBundle>
    </React.StrictMode>,
    setupESP32UploadFileBundleElem
  );
}

const latexRenderElem = document.getElementById('latex-render');
if (latexRenderElem !== null) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const tex = urlParams.get('tex');
  ReactDOM.render(
    <React.StrictMode>
      <MathComponent tex={String.raw`${tex}`}></MathComponent>
    </React.StrictMode>,
    latexRenderElem
  );
}

const mathjaxRenderElem = document.getElementById('mathjax-render');
if (mathjaxRenderElem !== null) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // Mathjax tutorial - https://math.meta.stackexchange.com/questions/5020/mathjax-basic-tutorial-and-quick-reference
  // Don't need to include $$ since we do it for you
  //
  // Go to https://www.urlencoder.io/ to encode something like:
  //  T=\begin{pmatrix}\mathbf{R}(\theta)&\mathbf{t}\\0&1\\\end{pmatrix}
  // ..and put that in the url get field 'tex'
  let tex = urlParams.get('tex');
  tex = '$$' + tex + '$$';
  ReactDOM.render(
    <React.StrictMode>
      <MathJax math={String.raw`${tex}`}></MathJax>
    </React.StrictMode>,
    mathjaxRenderElem
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
